// removed by extract-text-webpack-plugin
module.exports = {"input":"KeywordSearch-input-032a5e0d","error":"KeywordSearch-error-a03018a6","keywordInputBox":"KeywordSearch-keywordInputBox-94c41f94","icon":"KeywordSearch-icon-8ad6d20d"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/KeywordSearch.scss
// module id = 786
// module chunks = 0